import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingController, ModalController, NavController, ToastController } from '@ionic/angular';
import { BankAccountViewModel } from 'src/app/models/bankAccountViewModel';
import { BankService } from 'src/app/services/bank.service';
import { OrderService } from 'src/app/services/order.service';
import { SystemService } from 'src/app/services/system.service';
import { Security } from 'src/app/utils/security.util';
import { BankAccountComponent } from '../../bank/bank-account/bank-account.component';

@Component({
  selector: 'app-withdraw-by-transfer',
  templateUrl: './withdraw-by-transfer.component.html',
  styleUrls: ['./withdraw-by-transfer.component.scss'],
})
export class WithdrawByTransferComponent implements OnInit {
  form: FormGroup;
  bond = null;
  banks: BankAccountViewModel[] = [];
  bankSelected: any = 0;
  coin = 0;
  fee = 0.00;

  constructor(private fb: FormBuilder, private toastCtrl: ToastController, private loadingCtrl: LoadingController,
    private orderService: OrderService, private bankService: BankService, private navCtrl: NavController,
    private systemService: SystemService, private modalCrtl: ModalController) {
    this.form = this.fb.group({
      bondCoin: [],
      value: ['', Validators.compose([
        Validators.required
      ])],
      idBankaccount: ['', Validators.compose([
        Validators.required
      ])],
      finality: [0, Validators.compose([
        Validators.required
      ])],
      // email: ['', Validators.compose([
      //   Validators.required,
      //   Validators.email
      // ])],
    });
  }

  logForm() {
    console.log(this.form.value);
    ;
  }

  async ngOnInit() {
    const loading = await this.loadingCtrl.create({ message: 'Carregando...' });
    loading.present();

    this.bond = Security.getCoin();

    if (this.bond === '1') {
      this.coin = 1;
    }

    if (this.bond === '2') {
      this.coin = 2;
    }

    if (this.bond === '3') {
      this.coin = 3;
    }

    this.loadBanks();
    this.loadFeeTransferBetweenUsers();


    loading.dismiss();

  }

  loadBanks() {
    this.bankService.getByCoinUser(this.coin).subscribe(result => {
      if (result.success) {
        this.banks = result.data;
      }
    });
  }

  loadFeeTransferBetweenUsers() {
    this.systemService.getFeeTransferBetweenUsers().subscribe(result => {
      this.fee = result.data;
    });
  }

  async withdraw() {
    const loading = await this.loadingCtrl.create({ message: 'Processando...' });
    loading.present();

    this.form.patchValue({
      bondCoin: this.coin,
      idBankaccount: this.bankSelected.id
    });

    this.orderService.withdrawalByTransfer(this.form.value).subscribe(result => {
      if (result.success) {
        this.showMessage(result.message);
        loading.dismiss();
        this.goToPage('/master/wallet/home');
      } else {
        this.showMessage(result.message);
        loading.dismiss();
      }
    }, error => {
      this.showMessage(error.message);
      loading.dismiss();
    });
  }

  async showMessage(messagen) {
    const error = await this.toastCtrl.create({ message: messagen, duration: 3000 });
    error.present();
  }

  goToPage(page: string) {
    this.navCtrl.navigateRoot(page);
  }

  async addBankAccount(event) {
    if (event === '1') {

      const modal = await this.modalCrtl.create({
        component: BankAccountComponent
      });

      modal.onDidDismiss().then(() => {
        this.bankSelected = 0;
        this.loadBanks();
      });

      modal.present();
    }

  }
}
